export enum EnumMeioDePagamento {
  Cielo = "cielo",
  CieloCheckout = "cielocheckout",
  Pagarme = "pagarme",
  PagarmeHub = "pagarmehub",
  Pagseguro = "pagseguro",
  PagseguroConnect = "pagseguroconnect",
  MercadoPago = "mercadopago",
  CellcoinPay = "cellcoinpay",
  Getnet = "getnet"
}
